import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Property from './pages/Property';
import Login from './pages/Login';
import Register from './pages/Register';
import HostDashboard from './pages/HostDashboard';
import GuestDashboard from './pages/GuestDashboard';
import PaymentPage from './pages/Payment';
import Navbar from './components/Navbar';
import Admin from './pages/Admin';
import Booking from './pages/Booking';
import AdvancedSearch from './pages/AdvancedSearch';
import SearchResult from './pages/SearchResult';
import { useAuth } from './context/AuthContext';

function RequireAuth({ children, allowed = [] }) {
  const { user } = useAuth();

  // Daca inca se incarca user-ul (user === undefined), afiseaza loader
  if (user === undefined) return <div style={{ padding: 20 }}>Loading...</div>;

  // Daca nu e logat, redirectioneaza la login
  if (!user) return <Navigate to="/login" replace />;

  // Daca user-ul nu are rolul permis, redirectioneaza la home
  if (allowed.length && !allowed.includes(user.role)) return <Navigate to="/" replace />;

  return children;
}

export default function App() {
  return (
    <div className="app-root">
      <Navbar />
      <main className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/property/:id" element={<Property />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route
            path="/admin"
            element={
              <RequireAuth allowed={['admin']}>
                <Admin />
              </RequireAuth>
            }
          />

          <Route
            path="/host"
            element={
              <RequireAuth allowed={['host', 'admin']}>
                <HostDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/guest"
            element={
              <RequireAuth allowed={['guest', 'admin']}>
                <GuestDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/payment"
            element={
              <RequireAuth allowed={['guest', 'admin', 'host']}>
                <PaymentPage />
              </RequireAuth>
            }
          />
          <Route
            path="/booking/:id"
            element={
              <RequireAuth allowed={['guest', 'admin']}>
                <Booking />
              </RequireAuth>
            }
          />

          <Route path="/advanced-search" element={<AdvancedSearch />} />
          <Route path="/search" element={<SearchResult />} />


          <Route path="*" element={<div style={{ padding: 20 }}>404 - Not found</div>} />
        </Routes>
      </main>
    </div>
  );
}
